
import { Router } from './routes/Routes';

function App() {
    return (
        <div className='scroll'>
            <Router />
        </div>
    );
}

export default App;
